import React, { useState, useEffect } from "react";
import { Row, Col, Select, Form, Input, Button, message } from "antd";
import UploadImage from "../../midjourney/components/UploadImage";
import axios from "axios";
import { URL_API_KLING_CREATE_IMAGE } from "../../../../config";
import KlingPreview from "../components/KlingPreview";
export default function KlingCreateImg({
  onChangeLoading,
  onChangeCancel,
  onComplete,
}) {
  const [form] = Form.useForm();
  const [ratio, setRatio] = useState("1:1");
  const [url, setURL] = useState("");
  const [data, setData] = useState([]);
  const { TextArea } = Input;

  useEffect(() => {
    const queryLocal = localStorage.getItem("localStorageKlingCreateImage");
    if (queryLocal) {
      setData(JSON.parse(queryLocal));
    }
  }, []);

  const uniqueID = (length = 15) => {
    var result = "";
    var chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  };

  const handleChangeData = (v) => {
    setData(v);
    localStorage.setItem("localStorageKlingCreateImage", JSON.stringify(v));
  };

  const onFinish = async (v) => {
    onChangeLoading(true);
    let dataRequest = v;
    dataRequest.ratio = ratio;
    dataRequest.url = url ? url : "";
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    onChangeCancel(source);
    try {
      const create = await axios
        .post(URL_API_KLING_CREATE_IMAGE, dataRequest, {
          cancelToken: source.token,
          onDownloadProgress: function (progressEvent) {
            onComplete();
          },
        })
        .then((res) => res.data)
        .catch((thrown) => {
          message.error(thrown.message);
          onChangeLoading(false);
          onComplete();
        });
      const body = create.data;
      if (body.length <= 0) {
        message.error("Please try again, the system is busy or overloaded..!");
      } else {
        const newData = [
          ...data,
          {
            id: uniqueID(),
            data: body,
            ratio: ratio,
          },
        ];
        setData(newData);
        localStorage.setItem(
          "localStorageKlingCreateImage",
          JSON.stringify(newData)
        );
      }
      onChangeLoading(false);
    } catch (error) {
      onChangeLoading(false);
    }
  };

  const onFinishFailed = () => {};

  const handleChangeFile = (v) => {
    setURL(v);
  };

  return (
    <Row>
      <Col
        span={12}
        style={{
          position: "relative",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            name="text"
            label="Prompt"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <TextArea rows={5} />
          </Form.Item>
          <Form.Item name="ratio" label="Aspect">
            <Select
              defaultValue={ratio}
              style={{
                width: 120,
              }}
              onChange={(v) => {
                setRatio(v);
              }}
              options={[
                {
                  value: "1:1",
                  label: "1:1",
                },
                {
                  value: "2:3",
                  label: "2:3",
                },
                {
                  value: "3:2",
                  label: "3:2",
                },
                {
                  value: "4:3",
                  label: "4:3",
                },
                {
                  value: "3:4",
                  label: "3:4",
                },
                {
                  value: "19:6",
                  label: "19:6",
                },
                {
                  value: "9:16",
                  label: "9:16",
                },
              ]}
            />
          </Form.Item>
          <Form.Item label="Image">
            <UploadImage onChange={handleChangeFile} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Generation
            </Button>
          </Form.Item>
        </Form>
      </Col>

      <Col
        span={12}
        style={{
          position: "relative",
        }}
      >
        {data.length > 0 && (
          <KlingPreview
            onChangeData={handleChangeData}
            type="image"
            data={data}
          />
        )}
      </Col>
    </Row>
  );
}
